<template>
  <div class="text-center">
    <template>
      <v-stepper v-model="step" elevation="0">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 3" step="3"> </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="pb-0">
            <v-img
              src="@/assets/images/logo/authy.svg"
              height="30"
              class="mb-3"
              contain
            />
            <h6 class="text-center pb-2">
              Para usar o SuperAdmin é necessário cadastrar um autenticador.
            </h6>
            <h6 class="text--disabled text-center font-weight-medium mb-10">
              Recomendamos a utização do aplicativo
              <strong>Twilio Authy</strong>, disponível na
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=com.authy.authy&hl=pt_BR&gl=US"
                >Google Play</a
              >
              e
              <a
                target="_blank"
                href="https://apps.apple.com/us/app/twilio-authy/id494168017"
                >App Store</a
              >.
            </h6>

            <div class="d-flex justify-space-between">
              <v-btn text @click="cancelProcess"> Cancelar </v-btn>
              <v-btn color="primary" @click="step = 2"> Continuar </v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="2" class="pb-0">
            <div class="pb-4 d-flex justify-center">
              <qrcode-vue
                style="
                  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=);
                  background-size: cover;
                "
                class="d-flex justify-center pa-2 ma-1 white rounded"
                :value="code"
                size="190"
                level="M"
              />
            </div>

            <div class="text-left">
              <ol>
                <li>
                  Abra o aplicativo Authy e clique em
                  <strong>Adicionar Conta</strong>.
                </li>
                <li>
                  Selecione a opção
                  <strong>Escaneie o Código QR</strong>.
                </li>
                <li>Aponte a câmera do seu celular para o código acima.</li>
              </ol>
            </div>

            <div class="d-flex justify-space-between mt-4">
              <v-btn text @click="cancelProcess"> Cancelar </v-btn>
              <v-btn color="primary" @click="step = 3"> Continuar </v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="3" class="pb-0">
            <h6 class="text-center">Finalize o cadastro do autenticador.</h6>
            <h6 class="text--disabled text-center font-weight-medium">
              Digite o código de verificação gerado pelo aplicativo.
            </h6>
            <v-otp-input
              v-model="tokenCode"
              type="number"
              length="6"
            ></v-otp-input>

            <v-alert v-if="error" text type="error" class="mt-4 mb-0 text-left">
              {{ error }}
            </v-alert>

            <div class="d-flex justify-space-between mt-4">
              <v-btn @click="step = 2" text :disabled="loading"> Voltar </v-btn>
              <v-btn
                :disabled="tokenCode.length < 6"
                color="primary"
                @click="saveToken"
                :loading="loading"
              >
                Finalizar
              </v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="4" class="pb-0">
            <v-icon x-large color="success">mdi-check-circle</v-icon>
            <h6>Autenticador cadastrado com sucesso!</h6>
            <h6 class="text--secondary font-weight-medium">
              Agora você pode acessar o sistema ou cadastrar uma
              <b>Chave de Segurança</b>.
            </h6>
            <v-alert color="info" text dense class="text-12 mt-4">
              Recomendamos cadastrar uma <b>Chave de Segurança</b> para tornar
              seu acesso mais simples e seguro.
            </v-alert>
            <v-btn
              color="primary"
              :to="{ name: 'account.webauthn' }"
              :loading="loading"
              block
              class="mb-2 mt-4"
            >
              Cadastrar Chave de Segurança
            </v-btn>
            <v-btn
              small
              block
              :to="{ name: 'admin.index' }"
              text
              :disabled="loading"
            >
              Continuar para o sistema
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </div>
</template>

<script>
import ReCaptcha from "@/components/global/ReCaptcha.vue";
import AUTH from "@/services/auth";
import { mapActions } from "vuex";
import PhoneInput from "./PhoneInput.vue";
import { TOTP, Secret } from "otpauth/dist/otpauth.umd.min.js";
import QrcodeVue from "qrcode.vue";

export default {
  components: { ReCaptcha, PhoneInput, QrcodeVue },
  name: "Register2FA",
  data() {
    return {
      valid: false,
      step: 1,
      loading: false,
      error: false,
      code: "",
      tokenCode: "",
    };
  },
  methods: {
    ...mapActions("auth", ["setLogin"]),
    async saveToken() {
      this.loading = true;
      this.error = false;
      try {
        const response = await AUTH.twoFARegister(this.token, {
          token: this.tokenCode,
          secret: this.secret,
        });
        this.setLogin(response);
        this.step = 4;
      } catch (error) {
        this.error = error.message || "Erro ao salvar o token.";
        this.tokenCode = "";
      } finally {
        this.loading = false;
      }
    },
    cancelProcess() {
      this.$router.go();
    },
    processRecaptcha() {
      this.loading = true;
      this.error = false;
      this.$refs.recaptcha.execute();
    },
    recaptchaError(error) {
      this.loading = false;
      this.error = error;
    },
  },
  mounted() {
    const secret = new Secret({ size: 20 });
    this.secret = secret.base32;
    console.log(this.user);
    this.totp = new TOTP({
      issuer: "TiqOne",
      label: this.user?.phone,
      algorithm: "SHA1",
      digits: 6,
      period: 30,
      secret: secret,
    });
    this.code = this.totp.toString();
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    token: {
      type: String,
      default: "",
    },
  },
};
</script>
